import React from 'react';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/i18n/LanguageProvider';

const defaultDescription = 'Bellomonte & Pensabene, studio di architettura e interior design a Palermo. Progetti residenziali e commerciali su misura.';
const defaultImage = 'https://base44.app/api/apps/696b8a6ae79eec44c999be35/files/mp/public/696b8a6ae79eec44c999be35/f2eafcf5a_ChatGPTImage29lug202617_54_18AA.jpg';

export default function SEO({ 
  title, 
  description = defaultDescription, 
  keywords,
  image = defaultImage,
  type = 'website',
  structuredData
}) {
  const { language, t } = useLanguage();
  const siteTitle = language === 'en' ? 'Bellomonte & Pensabene - Architecture Studio' : 'Bellomonte & Pensabene - Studio di Architettura';
  const localizedTitle = title ? t(title) : '';
  const localizedDescription = t(description);
  const fullTitle = localizedTitle ? `${localizedTitle} | ${siteTitle}` : siteTitle;
  const siteUrl = window.location.origin;
  const currentUrl = window.location.href;

  return (
    <Helmet>
      <html lang={language} />
      <title>{fullTitle}</title>
      <meta name="description" content={localizedDescription} />
      <link rel="canonical" href={currentUrl} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={localizedDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={localizedTitle || siteTitle} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content={language === 'en' ? 'en_GB' : 'it_IT'} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={localizedDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={localizedTitle || siteTitle} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      
      {/* Organization Structured Data - Always present */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Bellomonte & Pensabene Studio di Architettura",
          "url": siteUrl,
          "logo": "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/696b8a6ae79eec44c999be35/51939c246_image-removebg-preview.png",
          "description": "Studio di architettura e interior design a Palermo specializzato in progetti residenziali e commerciali innovativi con tecnologia VR.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Viale Regione Siciliana Nord Ovest 2132",
            "addressLocality": "Palermo",
            "postalCode": "90135",
            "addressCountry": "IT"
          },
          "telephone": "+39 349 381 0464",
          "email": "rosariopensabenearc@yahoo.it",
          "sameAs": [
            "https://www.instagram.com/bellomontepensabene_architects/",
            "https://www.facebook.com/bellomontepensabene",
            "https://www.tiktok.com/@bellomontepensabene"
          ],
          "priceRange": "€€€"
        })}
      </script>
    </Helmet>
  );
}